module.exports = __webpack_public_path__ + "img/calculatex2.b8a3ae2c.png";